export default "__VITE_ASSET__BtqF2aHt__"